import React from 'react'
import { FormattedMessage } from 'react-intl';
import strings from '../../utils/strings';
import commonFunctions from '../../utils/commonFunctions'
import './RolesModal.css'
 
function RolesModal(props) {
  const { 
    selectedRole,
    roleName, setRoleName,
    roleDesc, setRoleDesc,
    selectedPermissions,
    availablePermissions,
    handleAddPermission,
    handleRemovePermission,
    // Validation Props
    submitted,
    roleNameValid,
    roleDescValid,
    permissionsValid,
    // Validation Functions
    handleRoleNameChange,
    handleRoleDescChange,
    handlePermissionChange,
    handleSubmit
  } = props;

  const allPermissions = Object.keys(availablePermissions).map((id) => {
    const permission = availablePermissions[id];
    return(
      <div className="list-group-item" key={id}>
        <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          value={id}
          onChange={handlePermissionChange}
          checked={selectedPermissions.includes(id)}
        />
          <label className="form-check-label" htmlFor={id}>
            <FormattedMessage id={permission.id} />
          </label>
          <div className="text-muted">{strings.permissionDescriptions[permission.id]}</div>
        </div>
      </div>
    )
  });

  return (
    <div className="modal fade" id="rolesModal" tabIndex="-1" aria-labelledby="rolesModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            {selectedRole ? (
              <h5 className="modal-title"><FormattedMessage id="EDIT_ROLE" /></h5>
            ) : <h5 className="modal-title"><FormattedMessage id="ADD_ROLE" /></h5>}
            <button type="button" id='closeRolesModal' className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form className="needs-validation">
              <div className="row mb-3">
                <label htmlFor="name" className="col-form-label"><FormattedMessage id="ROLE_NAME" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <div>
                  <input 
                    id="roleNameInput"
                    value={roleName} 
                    className={`form-control ${submitted && !roleNameValid ? "is-valid" : submitted && roleNameValid ? "is-invalid" : ""}`} 
                    name="roleName" 
                    onChange={handleRoleNameChange} />
                  {commonFunctions.InvalidFeedbackString(roleNameValid, "ROLE_NAME")}
                </div>
              </div>
              <div className="row mb-3">
                <label htmlFor="description" className="col-form-label"><FormattedMessage id="DESCRIPTION" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <div className="textarea-wrapper">
                  <textarea 
                    id="roleDescInput"
                    value={roleDesc} 
                    className={`form-control ${submitted && !roleDescValid ? "is-valid" : submitted && roleDescValid ? "is-invalid" : ""}`} 
                    name="roleDesc"
                    onChange={handleRoleDescChange}
                  />
                  {commonFunctions.InvalidFeedbackString(roleDescValid, "DESCRIPTION")}
                </div>
              </div>
              <div className="row mb-3">
                <label htmlFor="description" className="col-form-label"><FormattedMessage id="PERMISSIONS" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <div className="list-group" id="permissionsList">
                  {allPermissions}
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer mt-2">
            <button id="roleSaveBtn" className="btn save-btn" type="submit" onClick={handleSubmit}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RolesModal
